module.exports = __webpack_public_path__ + "img/gd.b5e51c48.svg";